// tslint:disable
import React, { useState, useEffect, useContext } from 'react';
import { IRootState } from 'src/reducers';
import { useSelector } from 'react-redux';
import { useFetch } from 'use-http';
import { Url } from 'src/api';
import CardContainer from 'src/components/common/CardContainer.redesign';
import Button from 'src/components/controls/forms/redesign/FormButton';
import EasternTownshipCard from './EasternTownshipCard';
import { DialogContext, dialogCreators } from 'src/providers/DialogProvider';

interface IEasternTownshipListProps {
    setTractListId: (tractListId: number) => void;
}

const EasternTownshipList: React.FC<IEasternTownshipListProps> = (props) => {
    const appContext = useSelector((state: IRootState) => state.appContext);
    const { get, response } = useFetch();
    const [dataLoaded, setDataLoaded] = useState(false);
    const [townshipIds, setTownshipIds] = useState([]);
    const [selectedTownship, setSelectedTownship] = useState(0);
    const dialogContext = useContext<dialogCreators>(DialogContext);

    const loadInitialData = async () => {
        const data = await get(`${Url.project.getAreas(appContext)}?select=id`);

        if (response.ok) {
            setTownshipIds(data);

            if (appContext.mapNumber) {
                const mapData = await get(`${Url.project.getEasternMap(appContext, appContext.mapNumber)}`);
                if (response.ok && mapData?.easternTownshipId) {
                    setSelectedTownship(mapData.easternTownshipId);
                } else {
                    setSelectedTownship(data[0]);
                }
            } else {
                setSelectedTownship(data[0]);
            }

            setDataLoaded(true);
        }
    };

    const onTownshipSelected = (townshipId: number) => {
        setSelectedTownship(townshipId);
    };

    const reloadTownships = async (townshipId: number) => {
        setDataLoaded(false);
        setTownshipIds([]);
        await loadInitialData();
        setSelectedTownship(townshipId);
    };

    useEffect(() => {
        loadInitialData();
    }, []);

    if (!dataLoaded) {
        return <div>Loading...</div>;
    } else if (townshipIds.length === 0) {
        return (
            <>
                <div style={{ display: 'flex', justifyContent: 'space-between', margin: '1rem', background: '#ddd', padding: '.8rem' }}>
                    <div style={{ height: '100%', verticalAlign: 'center', fontWeight: 'bold', fontSize: '1.3em' }}>Townships</div>
                    <div>
                        <Button
                            size="small"
                            intent="primary"
                            text="Create Township"
                            onClick={() => dialogContext.project.addUpdateDeleteEasternTownship(0, 'create', reloadTownships)}
                        />
                    </div>
                </div>
                <div style={{ padding: '2rem', border: '2px red solid', margin: '1rem', textAlign: 'center', fontWeight: 'bold', fontSize: '1.1em' }}>
                    No Townships Found.
                </div>
            </>
        );
    } else {
        return (
            <>
                {/* <Filter items={[]} /> */}
                <div style={{ display: 'flex', justifyContent: 'space-between', margin: '1rem', background: '#ddd', padding: '.8rem' }}>
                    <div style={{ height: '100%', verticalAlign: 'center', fontWeight: 'bold', fontSize: '1.3em' }}>Townships</div>
                    <div>
                        <Button
                            size="small"
                            intent="primary"
                            text="Create Township"
                            onClick={() =>
                                dialogContext.project.addUpdateDeleteEasternTownship(0, 'create', async (townshipId: number) => {
                                    props.setTractListId(undefined);
                                    await reloadTownships(townshipId);
                                    setSelectedTownship(townshipId);
                                })
                            }
                        />
                    </div>
                </div>
                <CardContainer>
                    {townshipIds.map((id) => (
                        <EasternTownshipCard
                            key={id}
                            townshipId={id}
                            isActive={selectedTownship === id}
                            onTownshipSelected={onTownshipSelected}
                            onMapSelected={props.setTractListId}
                            reoloadTownships={reloadTownships}
                        />
                    ))}
                </CardContainer>
            </>
        );
    }
};

export default EasternTownshipList;



// WEBPACK FOOTER //
// ./src/components/project/sections/tract/components/EasternTownshipList.tsx